import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AppLogout = ({ children }) => {
  const navigate = useNavigate();
  const timeOut = 45 * 60 * 1000;
  let timer;

  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      logoutAction();
    }, timeOut);
  };

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    resetTimer();
    handleLogoutTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutAction = () => {    
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("UserAppLangId");
      sessionStorage.removeItem("TranslationText");
    navigate("/login");
  };

  return children;
};

export default AppLogout;
